import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPublicMemoirs } from '../redux/actions/memoir.action';
import Avatar from 'react-avatar';
import moment from 'moment';
import MemoraLogo from '../assets/imgs/memora_logo_small.png';
import { Col, Container, Row, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
const PublicMemoirs = props => {
	const { publicMemoirs } = useSelector(state => state.memoir);
	// console.log('public memoirs', publicMemoirs);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getPublicMemoirs());
	}, []);
	// console.log('first');
	return (
		<>
			<div id='blog' className='mt-5'>
				<Container>
					<div
						style={{ width: '100%', maxWidth: '380px' }}
						className='text-center mx-auto'
					>
						<h1
							className='text-uppercase section-title '
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Public Memoirs
						</h1>
						<p>
							Tips, stories and tons of amazing content.
							<br />
							Get them weekly in your inbox
						</p>
					</div>
				</Container>
			</div>
			<Container>
				<Row
					className='mt-5  mb-5'
					// style={{ overflow: 'auto' }}
				>
					{publicMemoirs && publicMemoirs.length > 0 ? (
						publicMemoirs
							.filter(data => {
								if (props.search == '') {
									return data;
								} else if (
									data.memoir_title
										.toLowerCase()
										.includes(props.search.toLowerCase())
								) {
									return data;
								}
							})
							.map((mem, index) => (
								<Col lg='4' md='6' xs='12' className='mb-4'>
									<Link
										to={`/main/timeline/${mem.id}`}
										target={'_blank'}
									>
										<Card key={index}>
											<div
												className={`position-relative ${
													mem && mem.cover_image
														? 'memoir-cover-image'
														: 'memoir-default-cover'
												}`}
												style={{
													backgroundImage: `url(${
														mem && mem.cover_image
													})`,
													height: '130px',
												}}
											>
												<div
													className='position-absolute'
													style={{
														top: '100%',
														left: '50%',
														transform:
															'translate(-50%,-50%)',
													}}
												>
													{mem.display_image != '' ? (
														<Avatar
															round={true}
															size='64px'
															className='memoir_display_img'
															src={
																mem.display_image
															}
														/>
													) : (
														<Avatar
															round={true}
															size='64px'
															className='memoir_no_display_img'
															src={MemoraLogo}
														/>
													)}
												</div>
											</div>

											<div className='text-center text-dark'>
												<h5 className='font-weight-bold mt-4 pt-3'>
													{/* {mem.first_name} {mem.last_name} */}
													{mem.memoir_title}
												</h5>
												{/* <p className="f-14">{mem.introduction}</p> */}
												<p className='mt-2'>
													{mem.introduction.length >
													20
														? mem.introduction.slice(
																0,
																25
														  ) + '....'
														: mem.introduction}
												</p>
												{mem.category && (
													<p className='mt-2'>
														{mem.category}
													</p>
												)}
											</div>
											<div className='card-f f-14 py-1 d-flex justify-content-center mt-1  position-relative'>
												<span className='text-end'>
													{mem &&
														mem.created_at &&
														moment
															.unix(
																mem.created_at
																	.seconds
															)
															.format(
																'DD/MM/YYYY'
															)}
												</span>
											</div>
										</Card>
									</Link>
								</Col>
							))
					) : (
						<Col>
							<h4>No Memoirs Found</h4>
						</Col>
					)}
				</Row>
			</Container>
		</>
	);
};

export default PublicMemoirs;
